module.exports = __webpack_public_path__ + "img/icon_redeem_code2.24600689.svg";